if (!customElements.get('cs-product-swatch')) {
  class ProductSwatch extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.handleClick);
      }
    
      handleClick(e) {
        e.preventDefault();   
        const target = e.currentTarget;
        
        document.querySelectorAll('cs-product-swatch [js-product-anchor]').forEach(swatch => {
            swatch.classList.remove('active');
        })
      
        target?.querySelector('[js-product-anchor]')?.classList.add('active');
        const productUrl = this.dataset.productUrl
         // render new contents
         this.renderSections(productUrl)
      }
      getSectionsToRender() {
        return [
            {
              selector: "js-page-main-product-wrapper",
              sectionId: this.closest("[js-page-main-product-wrapper]")?.dataset.section
            }
        ]
    } 
    renderSections(productUrl) {
        const self = this;
        this.getSectionsToRender().forEach(section=> {

          let url = `${location.origin}${productUrl}?view=page-ajax`;

          console.log({ url })

          fetch(`${url}`)
          .then(response=>response.text())
          .then(html=>{

              const doc = new DOMParser().parseFromString(html, "text/html");
              const elementAjax = doc.querySelector(`[${section.selector}]`);
              const elementToReplace = document.querySelector(`[${section.selector}]`);

              console.log({ elementAjax })
              console.log({ elementToReplace })

              if(elementToReplace && elementAjax ) {
                  elementToReplace.innerHTML ='';
                  elementToReplace.replaceWith(elementAjax)
              }
              switch (section.selector) {
                case "js-page-main-product-wrapper":
                    document.dispatchEvent(new CustomEvent('product-page-script:init'));
                    document.dispatchEvent(new CustomEvent('custom-select:init'));
                break;
              }               
          }).catch(function(error) {
              console.log(error)
          })
           
        })
    }
  }
  
  customElements.define('cs-product-swatch', ProductSwatch);
}